// extracted by mini-css-extract-plugin
export default {"formContainer":"Pa0RF","totalContainer":"c54Tl","submitContainer":"w7R--","cancelButton":"vaA7j","title":"q0x8u","description":"lezUC","skeleton-progress":"ZoFoK"};